<template>
  <div class="container">
    <div class="row">
      <div class="col-md-3 col-lg-2 col-xl-2 navbar-collapse sidebar">
        <div class="page-title">
          <div class="title">
            <h1>Vulnerabilities</h1>
          </div>
        </div>
        <div class="sidebar-header">
          <a class="vik-brand" href="#">
            <img src="@/assets/logo.svg" alt />
          </a>
          <div id="dismissSidebar">
            <svg viewBox="0 0 24 24" width="24" height="24" xmlns="http://www.w3.org/2000/svg"
              class="SideNav__closeIcon__56eIa" stroke="currentColor" tabindex="0">
              <path d="M1 1L23 23M1 23L23 1" />
            </svg>
          </div>
        </div>
        <div class="head-page" style="margin-bottom: 30px">
          <router-link tag="button" :to="{ name: 'SingleVulnerability', params: { id: 'new' } }"
            class="btn btn-primary btn-lg">
            <i class="vik vik-plus"></i>New vulnerability
          </router-link>
        </div>

        <div class="category-list">
          <h2>Severity</h2>
          <ul class="category">
            <li v-for="sev in severities" :key="sev"
              v-bind:class="{ active: isActiveMenuItem('severity', sev) }">
              <a @click="addParam('severity', sev)" type="button">{{ capitalize(sev) }}</a>
              <button class="action" v-if="isActiveMenuItem('severity', sev)" @click="removeParam('severity')">
                ×
              </button>
            </li>
          </ul>
        </div>
      </div>

      <div class="col">
        <div class="content" ref="loaderLayout">
          <div class="filter-atom">
            <div class="search-group">
              <input type="text" class="form-control form-control-md" placeholder="type a word..." v-model="query" />
              <div class="input-icon">
                <i class="vik vik-search"></i>
              </div>
            </div>
          </div>

          <div class="market-page">
            <div class="filter-result" v-if="paramsToTags().length > 0">
              <div class="filter-result-text">
                <span class="text-bold">{{ total }} results</span>
                <span>filtered by</span>
              </div>
              <div class="tags">
                <span class="action" v-for="(tag, idx) in paramsToTags()" :key="idx">
                  {{ tag.value }}
                  <a type="button" class="tag-delete" @click="removeParam(tag.name)">×</a>
                </span>
              </div>
            </div>
          </div>

          <div v-if="records.length" class="row item-container atom-list">
            <div class="col-lg-6" :key="item.vulnerability_id" v-for="item in records">
              <article class="mini-card">
                <div class="mini-card-type" :class="severityClass(item.severity)">
                  <span>{{ item.severity || 'n/a' }}</span>
                </div>
                <router-link :to="{ name: 'SingleVulnerability', params: { id: item.vulnerability_id } }">
                  <div class="mini-article-card-title">
                    <h3>{{ item.name.substring(0, 100) }}</h3>
                    <p>{{ item.description }}</p>
                    <div class="tags" v-if="parsedTags(item.tags).length">
                      <span v-for="tag in parsedTags(item.tags)" :key="tag">{{ tag }}</span>
                    </div>
                    <p v-if="item.cvss != null" class="cvss-badge">CVSS: {{ item.cvss }}</p>
                  </div>
                </router-link>
              </article>
            </div>
          </div>
          <div v-else>no matches</div>
          <el-pagination background layout="prev, pager, next" :total="total" @current-change="changePage"
            :hide-on-single-page="true" :page-size="pageSize"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as utils from "@/utils.js";
import _ from "lodash";

export default {
  data() {
    return {
      query: "",
      total: 0,
      pageNum: 1,
      pageSize: 20,
      records: [],
      severities: ["info", "low", "medium", "high", "critical"],
    };
  },
  watch: {
    $route(to, from) {
      if (to.name != from.name) {
        this.pageNum = 1;
      }
      this.loadRecords();
    },
    query() {
      this.queryUpdate();
    },
  },
  mounted() {
    this.loadRecords();
  },
  methods: {
    capitalize(s) {
      return utils.capitalize(s);
    },
    severityClass(sev) {
      return sev ? `sev-${sev}` : "";
    },
    parsedTags(tags) {
      if (!tags) return [];
      try {
        const arr = typeof tags === "string" ? JSON.parse(tags) : tags;
        return Array.isArray(arr) ? arr : [];
      } catch (e) {
        return [];
      }
    },
    isActiveMenuItem(k, v) {
      return this.$route.query[k] && this.$route.query[k] === v;
    },
    changePage(pageNum) {
      this.pageNum = pageNum;
      this.loadRecords();
    },
    addParam(k, v) {
      utils.addQueryParam(this, k, v);
    },
    removeParam(k) {
      utils.removeQueryParam(this, k);
    },
    paramsToTags() {
      let tags = [];
      let obj = Object.assign({}, this.$route.query);
      for (let name in obj) {
        if (name == "severity") {
          tags.push({ name: name, value: obj[name] });
        }
      }
      return tags;
    },
    queryUpdate: _.throttle(function () {
      this.loadRecords();
    }, 800),
    async loadRecords() {
      let that = this;
      let params = Object.assign({}, this.$route.query, {
        page: this.pageNum,
        pageSize: this.pageSize,
        query: this.query,
      });
      utils.$get(`/api/vulnerabilities/?${utils.objectToString(params)}`).then((data) => {
        if (data.error) {
          that.$notify({
            title: "Error",
            message: data.error,
            type: "error",
          });
          return;
        }
        that.total = data.Total;
        that.records = data.Records || [];
      });
    },
  },
};
</script>

<style scoped>
.cvss-badge {
  margin-top: 8px;
  font-size: 12px;
  color: #8492a6;
}
.sev-info { background: #909399; }
.sev-low { background: #67c23a; }
.sev-medium { background: #e6a23c; }
.sev-high { background: #f56c6c; }
.sev-critical { background: #c0392b; }
</style>



// WEBPACK FOOTER //
// src/pages/Vulnerabilities.vue